import React from "react";
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

export const InputField = ({
    label, type = "text", name, value, onChange, placeholder, maxlength, showDollar = false, width, readOnly = false, }) => {
    const inputStyle = { width: width || "100%", paddingLeft: showDollar ? "30px" : undefined, cursor: readOnly ? "pointer" : "text" };

    return (
        <div className="position-relative">
            {label && <label className="form-label">{label}</label>}
            <input type={type} name={name} className="form-control" placeholder={placeholder} value={value || ""} onChange={onChange}
                maxLength={maxlength} readOnly={readOnly} style={inputStyle} />
        </div>
    );
};

export const SelectField = ({ id, label, name, options, value, onChange, readOnly = false, isMulti = false, isClearable = true,
    placeholder, isDisabled = false }) => {
    return (
        <div>
            {label && <label>{label}</label>}
            <Select
                id={id}
                name={name}
                isClearable={isClearable}
                className="basic-single"
                classNamePrefix="select"
                options={options}
                isMulti={isMulti}
                readOnly={readOnly}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                isDisabled={isDisabled}
                style={{ cursor: readOnly ? "pointer" : "text" }}
            />
        </div>
    );
};

export const DatePickerField = ({
    label, name, value, onChange, placeholder = "MM, DD, YYYY", mode = "range", readOnly = false, }) => {
    return (
        <div>
            {label && <label>{label}</label>}
            <Flatpickr
                name={name}
                className="form-control d-block"
                options={{ altInput: true, altFormat: "F j, Y", dateFormat: "Y-m-d", mode: mode }}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                readOnly={readOnly}
                style={{ cursor: readOnly ? "pointer" : "text" }}
            />
        </div >
    );
};
